import axios from '../axios'

/**
 * 单点登录
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19172052 
 */
 export const sso = data => {
  return axios({
    url: '/userCenterLogin',
    method: 'post', data
  })
}
/**
 * 用户中心 心跳
 * @param {*} param0 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19172049 
 */
export const touchUserCenterHeartBeat = ({userId, loginRecord}) => {
  return axios({
    url: `/heart/${userId}/${loginRecord}`,
  })
}
/*
 * 系统登录模块
 */

// 登录
export const login = data => {
    return axios({
        url: '/login',
        method: 'post',
        data
    })
}

// 登出
export const logout = () => {
    return axios({
        url: '/logout',
        method: 'get'
    })
}

// 获取验证码
export const getCodeImg = () => {
  return axios({
    url: '/captcha',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/login.js